import IndexPage from '@/components/Index.vue'
import QuemSomosPage from '@/components/pages/QuemSomos.vue'
import CursosPage from '@/components/pages/Cursos.vue'
import CursoPage from '@/components/pages/Curso.vue'
import CursoInscricaoPage from '@/components/pages/CursoInscricao.vue'
import XiiEncontroPage from '@/components/pages/XiiEncontro.vue'
import SupervisaoPage from '@/components/pages/Supervisao.vue'
import GrupoDeEstudosPage from '@/components/pages/GrupoDeEstudos.vue'
import ContatoPage from '@/components/pages/Contato.vue'
import LoginPage from '@/components/Login.vue'
import RecuperarAcessoPage from '@/components/RecuperarAcesso.vue'
import AtualizaSenhaPage from '@/components/AtualizaSenha.vue'
import CadastroPage from '@/components/pages/Cadastro.vue'


import {activateRegister, checkAuth, requireAuth, requireUnauth, requireLogout} from './base.js'

export default [
  {
    path: '/',
    name: 'index',
    component: IndexPage,
    beforeEnter: checkAuth
    
  },
  {
    path: '/ativar-cadastro/:token',
    name: 'ativar-cadastro',
    component: IndexPage,
    beforeEnter: activateRegister
    
  },
  {
    path: '/p/quem-somos',
    name: 'quem-somos',
    component: QuemSomosPage,
    beforeEnter: checkAuth
    
  },
  {
    path: '/p/cursos',
    name: 'cursos',
    component: CursosPage,
    beforeEnter: checkAuth
    
  },
  {
    path: '/p/cadastro',
    name: 'Cadastro',
    component: CadastroPage,
    beforeEnter: checkAuth
    
  },
  {
    path: '/p/curso/:curso',
    name: 'curso',
    component: CursoPage,
    beforeEnter: checkAuth
    
  },
  {
    path: '/p/curso/:curso/inscricao',
    name: 'curso-inscricao',
    component: CursoInscricaoPage,
    beforeEnter: requireAuth
    
  },
  {
    path: '/p/xii-encontro',
    name: 'xii-encontro',
    component: XiiEncontroPage,
    beforeEnter: checkAuth
    
  },
  {
    path: '/p/supervisao',
    name: 'supervisao',
    component: SupervisaoPage,
    beforeEnter: checkAuth
    
  },
  {
    path: '/p/grupo-de-estudos',
    name: 'grupo-de-estudos',
    component: GrupoDeEstudosPage,
    beforeEnter: checkAuth
    
  },
  {
    path: '/p/contato',
    name: 'contato',
    component: ContatoPage,
    beforeEnter: checkAuth
    
  },
  {
    path: '/session/sair',
    name: 'sair',
    component: IndexPage,
    beforeEnter: requireLogout
    
  },
  {
    path: '/p/login',
    name: 'login',
    component: LoginPage,
    beforeEnter: requireUnauth
    
  },
  {
    path: '/p/recuperar-acesso',
    name: 'recuperar-acesso',
    component: RecuperarAcessoPage,
    beforeEnter: requireUnauth
    
  },
   {
    path: '/p/atualizar-senha/:token',
    name: 'atualiza-senha',
    component: AtualizaSenhaPage,
    beforeEnter: requireUnauth
    
  },
   {
    path: '*',
    name: 'NotFind',
    component: IndexPage,
  },
]
